<template>
  <div id="app">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="loadTop"
      :disabled="isPullDisabled"
    >
      <template #pulling>下拉即可刷新</template>
      <template #loosing>释放即可刷新</template>
      <transition v-if="$route.meta.keepAlive" name="fade" mode="out-in">
        <keep-alive>
          <div class="page no-scroll-bar" id="page" ref="page">
            <router-view ref="app" :key="activeDate" v-stop v-wechat-title="$route.meta.pageTitle"></router-view>
          </div>
        </keep-alive>
      </transition>
      <transition v-else name="fade" mode="out-in">
        <div class="page no-scroll-bar" id="page" ref="page">
          <router-view ref="app" :key="activeDate" v-stop v-wechat-title="$route.meta.pageTitle"></router-view>
        </div>
      </transition>
    </van-pull-refresh>
  </div>
</template>

<script>
import { PullRefresh } from 'vant';
import app from '@/common/app';
import config from '@/config';

export default {
  name: 'app',
  data() {
    return {
      activeDate: Date.now().toString().slice(0, 10),
      barHeight: {
        height: '0px',
      },
      specialRouter: ['/manage-order', '/manage-stock', '/manage-stock-history'], // 此路由下对于下拉刷新有特殊处理
      isLoading: false,
      scrollTop: 0,
    };
  },
  provide() {
    return {
      barStyle: this.barHeight,
    };
  },
  computed: {
    isPullDisabled() {
      if (this.scrollTop !== 0) return true;
      const routeName = this.$route.path;
      const item = this.specialRouter.find(el => el === routeName);
      const child = config.closePullRouter.find(el => el === routeName);
      if (child) return true;
      if (!item) return false;
      return !this.$store.state.canPullRefresh;
    },
  },
  components: {
    vanPullRefresh: PullRefresh,
  },
  created() {
    const params = {
      cb: this.getBarH,
    };
    app.getStatusBarHeight(params);
  },
  mounted() {
    this.listenScroll();
    this.initAppCallBack();
  },
  directives: {
    stop: {
      inserted: function (el) {
        function stop(e) {
          let contentNode = el.querySelector('.body');
          if (!contentNode) return false;
          if (contentNode.scrollTop !== 0) {
            e.stopPropagation();
          }
        }
        el.addEventListener('touchstart', stop);
        el.addEventListener('touchmove', stop);
        el.addEventListener('touchend', stop);
      },
    },
  },
  methods: {
    initAppCallBack () {
      // app传入当前角色值
      window.changeWebRoleType = (parmas) => {
        console.log('changeWebRoleType callBack');
        this.$refs['app'].changeWebRoleType && this.$refs['app'].changeWebRoleType(parmas);
      };
      // 刷新，目前针对指定页面返回调用
      window.init = (parmas) => {
        console.log('init callBack');
        this.$refs['app'].backRefresh && this.$refs['app'].backRefresh(parmas);
      };
    },
    listenScroll() {
      const vm = this;
      const dom = document.querySelector('#page');
      if (!dom) return false;
      dom.addEventListener('scroll', function () {
        vm.scrollTop = this.scrollTop;
      });
    },
    getBarH(res) {
      console.log(`getBarH: 接收到参数${res}`);
      this.barHeight.height = `${res}px`;
    },
    loadTop() {
      [].slice.call(document.querySelectorAll('.hjx-modal')).forEach(dom => {
        dom.parentElement.removeChild(dom);
      });
      this.activeDate = Date.now().toString().slice(0, 10);
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100%;
  font-size: 14px;
  position: relative;
  background: #f7f7f7;
}
.page {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
#app .van-pull-refresh,
#app .van-pull-refresh__track {
  width: 100%;
  height: 100%;
}
</style>

